export class QuoteEntryRequestModel {
    productCode: string = null;
    basePrice: number = null;
    quantity: number = null;
}

